import { createContext } from 'react';

import type { AuthStore } from './useAuthFormStore';

const AuthFormContext = createContext<AuthStore>(null);

export { AuthFormContext };
